import { put, call } from 'redux-saga/effects';
import * as actions from '../actions';
import { generateOTP } from '../../api/application';

export function* generateOTPSaga(action) {
    try {
        const response = yield call(generateOTP, action.sessionId, action.mobileNo);
        yield put(actions.onGenerateOTPSuccess(response.data.data));
        yield put(actions.stageSuccess(8));
    } catch (error) {
        yield put(actions.onGenerateOTPFailed(error.response.data));
    }
}


